import { Link } from "react-router-dom";
import { ThemeSelector } from "./ThemeSelector";
import { MainMenu } from "./MainMenu";

type NavbarProps = {
    title?: string;
};

export function Navbar({ title }: NavbarProps) {
    return (
        <div className="navbar bg-base-300 border-b border-base-content/10 px-4 min-h-[3rem] h-12 z-10">
            <div className="flex-1 gap-2 items-center text-sm breadcrumbs">
                <ul>
                    <li>
                        <Link to="/" className="font-bold text-lg tracking-wide opacity-80 hover:opacity-100 transition-opacity no-underline">
                            Shonei's Blog
                        </Link>
                    </li>
                    {title && (
                        <li>
                            <span className="font-medium text-lg opacity-80 line-clamp-1 max-w-[200px] sm:max-w-md">
                                {title}
                            </span>
                        </li>
                    )}
                </ul>
            </div>
            <div className="flex-none gap-2">
                <ThemeSelector />
                <MainMenu />
            </div>
        </div>
    );
}
